// composables/useCompanyFormData.ts
import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useVoucherAssignmentData(companyId?: number) {
    const { data: voucherAssignmentData, isPending: loadingVoucherAssignmentData } = useQuery({
        gcTime: 0,
        queryKey: [QueryKey.COMPANY_VOUCHER_ASSIGNMENT, companyId],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.companies.voucher-assignment.edit', { company: companyId }),
            );
            return data;
        },
        placeholderData: [],
        enabled: !!companyId,
    });

    return {
        voucherAssignmentData,
        loadingVoucherAssignmentData,
    };
}
